import React, { FC } from 'react';
import { TeamID } from '../../../scripts/models/common';
import { PlayerModel } from '../../../scripts/models/models';
import Tooltip from '../../common/tooltip/Tooltip';
import { DataContext } from '../../context/dataLoader/DataLoader';

import './FieldChart.scss';

interface IProps {
    team?: TeamID
}

interface playerWithCertainty extends PlayerModel {
    uncertain?: boolean
}

interface fieldCell {
    name: string,
    players: playerWithCertainty[],
}

const positionNames = [
    ["Left Cornerfielder", "Back stop", "Left Wallrunner", "Left Outerfielder", "Left Highfielder", "Highfielder"],
    ["5th base", "Long stop", "Left Fielder", "Left Ranger", "Center Fielder", "Right Highfielder"],
    ["Left Liner", "Mid stop", "Left Midfielder", "Midfielder", "Right Ranger", "Right Outerfielder"],
    ["3rd Base", "Short stop", "2nd base", "Right Midfielder", "Right Fielder", "Right Wallrunner"],
    ["Left Guard", "Center infielder", "Flanker", "Mid Flanker", "Long Flanker", "Back Flanker"],
    ["4th base", "Right Guard", "1st base", "Right Liner", "0th base", "Right Cornerfielder"],
]


const FieldChart: FC<IProps> = (props) => {
    const { team: teamId } = props

    const { playerCollections } = React.useContext(DataContext)

    const field: fieldCell[][] = (positionNames.map(row => row.map(name => { return { name, players: [] } })));

    const orphans: PlayerModel[] = [];



    if (teamId) {
        if (!playerCollections) {

            return <div>
                Loading...
            </div>
        }
        const lineup = playerCollections.playersByTeam[teamId]["LINEUP"]
        lineup.forEach((defender) => {
            defender.positions.forEach((position, idx) => {
                const defenderWithCertainty: playerWithCertainty = {
                    uncertain: (idx + 1) < defender.positions.length,
                    ...defender
                }

                field[5 - position.y][position.x].players.push(defenderWithCertainty)
            })
            if (defender.positions.length === 0) {
                orphans.push(defender)
            }
        })
    }


    return (<div className='FieldChart'>
        <div className='container'>
            {field.map((row, idx) => (
                <div className='row' key={idx}>
                    {row.map((cell, idx) => (
                        <div className='cell' key={idx}>
                            <div className='rotateFix'>
                                {cell.players.length === 0 ? (
                                    <span className={`positionName ${cell.name.length > 15 ? "long" : ""}`}>{cell.name}</span>
                                ) : (
                                    <div className='playerNames'>
                                        {cell.players.map((player, idx) => (
                                            <div key={idx} className={`name ${(player.uncertain) ? "uncertain" : ""}`}
                                                title={(player.uncertain) ? "This field position is probably not the current position" : ""}>
                                                {player.name}
                                            </div>
                                        ))}
                                        {
                                            (cell.players.length > 0) && (
                                                <Tooltip visibility='showOnHover'>{cell.name}</Tooltip>
                                            )
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
        {
            orphans.length > 0 && (
                <div className="orphans">
                    <div className='title'>Unlisted Players</div>
                    <div className='orphanList'>

                        {
                            orphans.map((orphan, idx) => (
                                <div key={idx}>
                                    {orphan.name}
                                </div>
                            ))
                        }
                    </div>
                </div>
            )
        }
    </div>)
}

export default FieldChart;